import Vue from 'vue'
import Router from 'vue-router'
import login from '@/view/login'
import screen1 from '@/view/page/screen1'
import screen2 from '@/view/page/screen2'
import screen3 from '@/view/page/screen3'

Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      name: 'login',
      component: login
    },
    {
      path: '/screen1',
      name: 'screen1',
      component: screen1
    },
    {
      path: '/screen2',
      name: 'screen2',
      component: screen2
    },
    {
      path: '/screen3',
      name: 'screen3',
      component: screen3
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js